import {
  buildParticipantsFilterUrl,
  refreshParticipantsLive
} from "packs/backoffice-participants-live-refresh"

const DEBOUNCE_MS = 400

const bindAutoSearchForm = (form) => {
  if (form.dataset.autoSearchBound === "true") return
  form.dataset.autoSearchBound = "true"

  const input = form.querySelector('[data-auto-search-input], input[type="search"], input[name="q"]')
  let timer = null

  const runLiveSearch = async () => {
    const urlBefore = buildParticipantsFilterUrl(form).toString()
    const ok = await refreshParticipantsLive(form)
    if (!ok || !input) return

    // Si l’utilisateur a continué à taper pendant le fetch, relancer.
    if (input.value !== (new URL(urlBefore).searchParams.get("q") || "")) {
      clearTimeout(timer)
      timer = setTimeout(runLiveSearch, DEBOUNCE_MS)
    }
  }

  const scheduleLiveSearch = () => {
    clearTimeout(timer)
    timer = setTimeout(runLiveSearch, DEBOUNCE_MS)
  }

  if (input) {
    input.addEventListener("input", scheduleLiveSearch)
    input.addEventListener("keydown", (event) => {
      if (event.key !== "Enter") return
      event.preventDefault()
      clearTimeout(timer)
      runLiveSearch()
    })
  }

  form.querySelectorAll("[data-auto-search-change]").forEach((field) => {
    field.addEventListener("change", () => {
      refreshParticipantsLive(form)
    })
  })
}

const initBackofficeAutoSearch = () => {
  document.querySelectorAll("form[data-auto-search]").forEach(bindAutoSearchForm)
}

export { initBackofficeAutoSearch }
